module.exports = __webpack_public_path__ + "img/mr.bf379763.svg";